module.exports = __webpack_public_path__ + "img/al.bfd0a0c.svg";